export const auth_constants = {
  USER_REGISTER_REQUEST: 'USER_REGISTER_REQUEST',
  USER_REGISTER_SUCCESS: 'USER_REGISTER_SUCCESS',
  USER_REGISTER_FAILURE: 'USER_REGISTER_FAILURE',

  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGOUT_REQUEST: 'LOGOUT_REQUEST',

  GET_UPDATED_USER_REQUEST: 'GET_UPDATED_USER_REQUEST',
  GET_UPDATED_USER_SUCCESS: 'GET_UPDATED_USER_SUCCESS',
  GET_UPDATED_USER_FAILURE: 'GET_UPDATED_USER_FAILURE',
}

export const user_constants = {
  FOOD_LIST_REQUEST: 'FOOD_LIST_REQUEST',
  FOOD_LIST_SUCCESS: 'FOOD_LIST_SUCCESS',
  FOOD_LIST_FAILURE: 'FOOD_LIST_FAILURE',

  CREATE_MEAL_PLAN_REQUEST: 'CREATE_MEAL_PLAN_REQUEST',
  CREATE_MEAL_PLAN_SUCCESS: 'CREATE_MEAL_PLAN_SUCCESS',
  CREATE_MEAL_PLAN_FAILURE: 'CREATE_MEAL_PLAN_FAILURE',

  UPDATE_MEAL_PLAN_REQUEST: 'UPDATE_MEAL_PLAN_REQUEST',
  UPDATE_MEAL_PLAN_SUCCESS: 'UPDATE_MEAL_PLAN_SUCCESS',
  UPDATE_MEAL_PLAN_FAILURE: 'UPDATE_MEAL_PLAN_FAILURE',

  MEAL_PLAN_EXISTS_REQUEST: 'MEAL_PLAN_EXISTS_REQUEST',
  MEAL_PLAN_EXISTS_SUCCESS: 'MEAL_PLAN_EXISTS_SUCCESS',
  MEAL_PLAN_EXISTS_FAILURE: 'MEAL_PLAN_EXISTS_FAILURE',

  GET_MEAL_PLAN_REQUEST: 'GET_MEAL_PLAN_REQUEST',
  GET_MEAL_PLAN_SUCCESS: 'GET_MEAL_PLAN_SUCCESS',
  GET_MEAL_PLAN_FAILURE: 'GET_MEAL_PLAN_FAILURE',

  DELETE_MEAL_PLAN_REQUEST: 'DELETE_MEAL_PLAN_REQUEST',
  DELETE_MEAL_PLAN_SUCCESS: 'DELETE_MEAL_PLAN_SUCCESS',
  DELETE_MEAL_PLAN_FAILURE: 'DELETE_MEAL_PLAN_FAILURE',

  GET_EXCERCISE_IMAGE_REQUEST: 'GET_EXCERCISE_IMAGE_REQUEST',
  GET_EXCERCISE_IMAGE_SUCCESS: 'GET_EXCERCISE_IMAGE_SUCCESS',
  GET_EXCERCISE_IMAGE_FAILURE: 'GET_EXCERCISE_IMAGE_FAILURE',

  GET_EXCERCISE_CALORIES_REQUEST: 'GET_EXCERCISE_CALORIES_REQUEST',
  GET_EXCERCISE_CALORIES_SUCCESS: 'GET_EXCERCISE_CALORIES_SUCCESS',
  GET_EXCERCISE_CALORIES_FAILURE: 'GET_EXCERCISE_CALORIES_FAILURE',

  CREATE_EXCERCISE_PLAN_REQUEST: 'CREATE_EXCERCISE_PLAN_REQUEST',
  CREATE_EXCERCISE_PLAN_SUCCESS: 'CREATE_EXCERCISE_PLAN_SUCCESS',
  CREATE_EXCERCISE_PLAN_FAILURE: 'CREATE_EXCERCISE_PLAN_FAILURE',

  GET_EXCERCISE_PLAN_REQUEST: 'GET_EXCERCISE_PLAN_REQUEST',
  GET_EXCERCISE_PLAN_SUCCESS: 'GET_EXCERCISE_PLAN_SUCCESS',
  GET_EXCERCISE_PLAN_FAILURE: 'GET_EXCERCISE_PLAN_FAILURE',

  EXCERCISE_PLAN_EXISTS_REQUEST: 'EXCERCISE_PLAN_EXISTS_REQUEST',
  EXCERCISE_PLAN_EXISTS_SUCCESS: 'EXCERCISE_PLAN_EXISTS_SUCCESS',
  EXCERCISE_PLAN_EXISTS_FAILURE: 'EXCERCISE_PLAN_EXISTS_FAILURE',

  UPDATE_EXCERCISE_PLAN_REQUEST: 'UPDATE_EXCERCISE_PLAN_REQUEST',
  UPDATE_EXCERCISE_PLAN_SUCCESS: 'UPDATE_EXCERCISE_PLAN_SUCCESS',
  UPDATE_EXCERCISE_PLAN_FAILURE: 'UPDATE_EXCERCISE_PLAN_FAILURE',

  GET_CURRENT_MONTH_PLAN_REQUEST: 'GET_CURRENT_MONTH_PLAN_REQUEST',
  GET_CURRENT_MONTH_PLAN_SUCCESS: 'GET_CURRENT_MONTH_PLAN_SUCCESS',
  GET_CURRENT_MONTH_PLAN_FAILURE: 'GET_CURRENT_MONTH_PLAN_FAILURE',

  GET_USER_GOAL_REQUEST: 'GET_USER_GOAL_REQUEST',
  GET_USER_GOAL_SUCCESS: 'GET_USER_GOAL_SUCCESS',
  GET_USER_GOAL_FAILURE: 'GET_USER_GOAL_FAILURE',

  GET_CHAT_BOT_MESSAGE_REQUEST: 'GET_CHAT_BOT_MESSAGE_REQUEST',
  GET_CHAT_BOT_MESSAGE_SUCCESS: 'GET_CHAT_BOT_MESSAGE_SUCCESS',
  GET_CHAT_BOT_MESSAGE_FAILURE: 'GET_CHAT_BOT_MESSAGE_FAILURE',
}
